import { createFileRoute } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { useCurrentAssistant } from '~/api'
import { Messages } from '~/components/student/chat/Messages'
import { demoThreadAtom } from '~/state'

export const Route = createFileRoute('/student/courses/$courseId/templates/$templateId')({
	component: NewChat,
})

function NewChat() {
	const assistant = useCurrentAssistant()
	const [demoThread, setDemoThread] = useAtom(demoThreadAtom)

	useEffect(() => {
		setDemoThread(null)
	}, [])

	return (
		<>
			<div className="bg-yellow-25 text-navy-100 mb-[16px] max-w-max rounded-[4px] px-[8px] py-[2px] text-[14px]">{assistant?.name}</div>
			<Messages messages={demoThread?.uiMessages} />
		</>
	)
}
